import logo from './logo.svg';
import './App.css';
import Privacy from "./privacidad"
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

function welcome() {
  return <h1>Welcome</h1>;
}

function App() {
  return (
    <Router>
        <div className={"site-content"}>
        <Route path="/" exact component={welcome} />
        <Route path="/privacidad/" component={Privacy} />
      </div>
    </Router>
  );
}


export default App;
